/**
 * [Pure] Compare deep equality of two objects.
 * @param obj1 - First object to compare.
 * @param obj2 - Second object to compare.
 */
export function equals(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;                                     // Return true if values match.
    if (typeof obj1 !== typeof obj2) return false;                      // Exit if different types.
    if (Array.isArray(obj1)) return obj1.reduce((result, e, i) => {     // If obj1 is an array:
        return !result ? false : equals(e, obj2[i]);                    // Compare each array index against obj2.
    }, true);
    if (!(obj1 instanceof Object)) return false;                        // Exit if not an object (means it's a value and the values don't match).
    const obj1Keys = Object.keys(obj1);                                 // Get keys from obj1.
    const obj2Keys = Object.keys(obj2);                                 // Get keys from obj2.
    if (obj1Keys.length !== obj2Keys.length) return false;              // Exit if different number of keys.
    for (let i = 0; i < obj1Keys.length; i++) {                         // Loop over object keys.
        if (obj2Keys.indexOf(obj1Keys[i]) === -1) return false;         // Exit if key doesn't exist in both objects.
        let val1 = obj1[obj1Keys[i]];                                   // Get value from obj1.
        let val2 = obj2[obj1Keys[i]];                                   // Get value from obj2.
        if (!equals(val1, val2)) return false;                          // Exit if values don't match.
    }
    return true;                                                        // Return true if nothing else exittedq.
}
